import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import config from '@/config';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
}

export default function SEOHead({ title, description, keywords }: SEOHeadProps) {
  const location = useLocation();

  const siteTitle = title
    ? `${title} | ${config.brand.name}`
    : `${config.brand.name} - ${config.brand.tagline}`;

  const canonicalUrl = `${config.siteUrl}${location.pathname}`;

  const defaultDescription =
    'KaamKaaj Online - Your one-stop shop for stationery items and digital services including printing, Aadhaar card, PAN card, passport, government schemes, exam applications, and more.';

  const metaDescription = description || defaultDescription;

  return (
    <Helmet>
      <title>{siteTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={config.brand.name} />
      <meta property="og:image" content={`${config.siteUrl}${config.brand.logo}`} />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={metaDescription} />
    </Helmet>
  );
}
